import React from 'react'
import axios from 'axios'
import moment from 'moment'

export default class Footer extends React.Component {
  state = {
    version: '1.0.0',
  }

  componentDidMount() {
    axios.get('/version.json').then(({ data }) => {
      if (data && data.version) {
        this.setState({ version: data.version })
      }
    })
  }

  render() {
    const { version } = this.state
    const year = moment().format('YYYY')

    return (
      <div className="footer-text">
        &#169; {year} BLAZE - v{version}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Footer.js